import React from 'react';
import { LearningPathsOverview } from '@/components/learningPaths/LearningPathsOverview';

export const LearningPaths: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <LearningPathsOverview />
    </div>
  );
};

export default LearningPaths;